// Mirrors /app/assets/stylesheets/old-style/base/typography.css.scss
// and     /app/views/lessons/_lesson_summary.html.slim

import {
  collection,
  lesson,
  post,
  flashcard,
  flashcardCategory,
  video,
  course,
  studyPack,
  poll,
} from './materialTypes'

export default {
  [lesson]: {
    icon: 'file-alt',
    text: 'Lesson',
  },
  resource: {
    icon: 'wrench',
    text: 'Resource',
  },
  [post]: {
    icon: 'pencil',
    text: 'Blog Post',
  },
  [flashcard]: {
    icon: 'bolt',
    text: 'Flashcard',
  },
  [flashcardCategory]: {
    icon: 'images',
    text: 'Flashcard Category',
  },
  featured: {
    icon: 'bookmark',
    text: 'Featured',
  },
  new_lesson: {
    icon: 'sparkles',
    text: 'New',
  },
  sample_label: {
    icon: 'unlock-alt',
    text: 'Sample',
  },
  free: {
    icon: 'unlock-alt',
    text: 'Free',
  },
  revised: {
    icon: 'redo',
    text: 'Revised',
  },
  coming_soon: {
    icon: 'clock',
    text: 'Coming Soon',
  },
  now_with_video: {
    icon: 'video',
    text: 'Now with video',
  },
  [collection]: {
    icon: 'list',
    text: 'Collection',
  },
  [video]: {
    icon: 'list',
    text: 'Video',
  },
  [course]: {
    icon: 'user-graduate',
    text: 'Course',
  },
  [studyPack]: {
    icon: 'backpack',
    text: 'Study Pack',
  },
  [poll]: {
    icon: 'poll-people',
    text: 'Gather',
  },
}
